import request from '@/utils/request'
const api_name = 'officecheckin'
export default{
    getAllOfficeCheckins(){
        return request({
            url:`/${api_name}/getallofficecheckins`,
            method:'get'
        })
    },
    getOfficeCheckinsByOfficeCheckin(pojo){
        return request({
            url:`/${api_name}/getofficecheckinbyofficecheckinsubject`,
            method:'post',
            data:pojo
        })
    },
    addOfficeCheckin(pojo){
        return request({
            url:`/${api_name}/addofficecheckinbyweb`,
            method:'post',
            data:pojo
        })
    },
    updateOfficeCheckin(pojo){
        return request({
            url:`/${api_name}/updateofficecheckin`,
            method:'post',
            data:pojo
        })
    },
    deleteOfficeCheckin(id){
        return request({
            url:`/${api_name}/deleteofficecheckin?id=`+id,
            method:'delete',
        })
    },
    
}







